import { Box, Skeleton, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    container: {
        width: "14rem",
        borderRadius: "1rem",
        overflow: "hidden",
        border: `1px solid ${theme.palette.tailwind.slate[300]}`,
        background: theme.palette.common.white,
        flexShrink: 0,
    },
    image: {
        width: "100%",
        height: "8.75rem",
        transform: "none",
        borderRadius: 0,
    },
    content: {
        padding: ".75rem",
        minHeight: "7.75rem",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    title: {
        transform: "none",
        borderRadius: ".375rem",
    },
    subtitle: {
        transform: "none",
        borderRadius: ".375rem",
    },
    price: {
        transform: "none",
        borderRadius: ".375rem",
    },
    counter: {
        transform: "none",
        borderRadius: ".375rem",
    },
}))

export function TakeawayProductCardSkeleton() {
    const { classes } = useStyles()

    return (
        <Box className={classes.container}>
            <Skeleton variant="rectangular" animation="wave" className={classes.image} />
            <Stack gap=".375rem" className={classes.content}>
                <Stack gap=".375rem">
                    <Skeleton variant="rounded" animation="wave" width="75%" height="1rem" className={classes.title} />
                    <Skeleton variant="rounded" animation="wave" width="50%" height=".875rem" className={classes.subtitle} />
                </Stack>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Skeleton variant="rounded" animation="wave" width="3.5rem" height="1rem" className={classes.price} />
                    <Skeleton variant="rounded" animation="wave" width="4rem" height="2rem" className={classes.counter} />
                </Stack>
            </Stack>
        </Box>
    )
}
